import React from "react";
import Select from "react-select";
import "./CustomSelect.scss";
import classNames from "classnames";

const CustomSelect = ({ label, id, options, required, value, onChange, placeholder = "Select option...", isMulti = false, error, className, description}) => {
    return (
        <div className={classNames("custom-select", className)}>
            {label &&
                <label className={classNames({"required": required})}>
                    {label}
                </label>
            }

            <Select
                inputId={id}
                isMulti={isMulti}
                options={options}
                required={required}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className="react-select-container"
                classNamePrefix="react-select"
                menuPosition="fixed"
            />

            {description && <p className="description">{description}</p>}
            {error && <p className="error">{error}</p>}
        </div>
    );
};

export default CustomSelect;